import { useQueryClient, useMutation } from '@tanstack/react-query';
import { quoteItemQueryKey } from '@services/quoteItem';
import { quoteFormQueryKeys } from '@services/quoteForm/keys';
import { useClient } from '@utils/api-client';

export const useResetQuoteDefaults = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = ({
    quoteId,
    resetAllQuoteItemAttributesThatDefault,
  }: {
    quoteId: string;
    resetAllQuoteItemAttributesThatDefault: boolean;
  }) => {
    const url = `quote/${quoteId}/quote-item-reset`;
    return client.post(url, {
      json: { resetAllQuoteItemAttributesThatDefault },
    });
  };
  const result = useMutation({
    mutationFn,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['quote', { quoteId: variables.quoteId }] });
      queryClient.invalidateQueries({ queryKey: quoteItemQueryKey.searchWithParams({ quoteId: variables.quoteId }) });
      queryClient.invalidateQueries({ queryKey: quoteFormQueryKeys.get(variables.quoteId) });
    },
  });
  return {
    ...result,
    reset: result.mutateAsync,
  };
};
